export default __webpack_public_path__ + "static/media/iden.f76abd7d.jpg";